//npm packages
import React, { memo, useState } from 'react';
import { faBackward, faCog } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';

//redux actions
import { preferenceList } from '../../redux/actions';

//elements starts with capital letter
import { GridBase } from '../../components';
import PreferenceForm from './PreferenceForm';
import { DynamicModal, UseModal } from '../../components/Model';

//helper files
import strings from '../../globalization';
import consts from '../../consts';

const PreferenceList = memo(props => {
  const history = useHistory(),
    { isShowing, toggle } = UseModal();
  const [state, setState] = useState({
    component: '',
    isShowing: false
  });

  const handleModify = (props, prevState) => {
    let isVisible = toggle(),
      { rowIdx, row, column } = prevState.clickedRowInfo;
    debugger;
    let component = <PreferenceForm {...props} hide={toggle} id={row._id} />;
    setState({ state, component: component, isShowing: isShowing });
  };

  const { component } = state;
  const advanceButtons = (
    <Button
      title={strings.Back}
      type="button"
      color="secondary"
      onClick={() => history.goBack()}
    >
      {' '}
      <FontAwesomeIcon icon={faBackward}></FontAwesomeIcon> {strings.Back}
    </Button>
  );

  const columns = [
    { key: 'PrefName', name: strings.Name, width: 150 },
    { key: 'PrefDesc', name: strings.Description, width: 300 },
    { key: 'IsDefault', name: strings.IsDefault, width: 100 }
  ];
  return (
    <GridBase
      {...props}
      key={Math.random()}
      action={preferenceList}
      columns={columns}
      parentRoute="managePreference"
      title={strings.Preferences}
      showAddButton={false}
      addIcon={faCog}
      disableFilter={true}
      disableShowHideColumns={true}
      dataProperty="preferenceListData"
      advanceButtons={advanceButtons}
      disableDelete={false}
      component={component}
      isShowing={isShowing}
      baseFilter={{ PrefName: { $ne: consts.AUTO_DEFAULT_PREFERENCE_NAME } }}
    />
  );
});

export default PreferenceList;
